module.exports = __webpack_public_path__ + "media/images/athletes/2831-27a8beb82af1fbdc393f02dd5834b184.png";